<div class="listing" [ngClass]="!isLoaded ? 'lazy-load lazy-load--listing' : ''" (click)="goToDetails()">
    <img class="listing-item" appLazyload (loadingDone)="loadingDone()" [useEmptyState]="true"
        [src]="source?.images ? ((source?.images[0] | imageUrl) | async) : ''">
    <div *ngIf="!isLoaded" class="empty-photo empty-photo--single"></div>
    <label class="title">{{ isLoaded ? (source?.name ? source?.name : 'No Title') : '' }}</label>
    <label class="price" *ngIf="isLoaded"> S{{ (source.rentalPrice | mcp) }} /day</label>
    <div *ngIf="source?.averageRating" class="rating">
        <app-rating-stars-label [rating]="source?.averageRating">
        </app-rating-stars-label>
    </div>
    <label class="location pin">
        <img src="./assets/images/map-pin.svg" />
        {{ isLoaded ? (source?.location ? source?.location : 'No Location specified') : '' }}
    </label>
</div>